import { Select, SelectProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FunctionCategoryValue } from '../../../../../../../redux/context/customReports/typesCategory'

const FunctionCategorySelect = (props: SelectProps) => {
  const { t } = useTranslation()
  return (
    <Select
      options={Object.values(FunctionCategoryValue).map(f => ({ value: f, label: t(`functionCategory:${f}`) }))}
      {...props}
    />
  )
}

export default FunctionCategorySelect
